import { IStackStyles, mergeStyles, ITextFieldStyles, IStackTokens, getTheme } from '@fluentui/react';

//const MODERATE_RED = '#d74654';
const MODERATE_RED = '#ff0000';
//const YELLOW = '#ffb100';
//const YELLOW = '#ffa500';
const YELLOW = '#A9a9a9';
const BLUE = 'rgb(12, 68, 172)';
const GREEN = '#32cd32';
const palette = getTheme().palette;
export const fullHeightStyles: IStackStyles = {
    root: {
        height: '100%',
        overflowY: 'auto'
    }
};
export const paneFooterStyles: IStackStyles = {
    root: {
        marginBottom: '1.25rem'
    }
};
export const paneFooterTokens: IStackTokens = {
    childrenGap: '0.3125rem'
};
export const textFieldStyles: Partial<ITextFieldStyles> = {
    field: {
        color: palette.neutralSecondary,
        padding: 0

    },
    root: {
        marginLeft: '1rem',
        /*marginRight: '1rem',*/
        marginRight: '0px',
        display: 'inline-block'
    },
    fieldGroup: {
        border: 'none',
        textAlignLast: 'center'
    }
};

export const textFieldStylesNoMargin: Partial<ITextFieldStyles> = {
    field: {
        color: palette.neutralSecondary,
        padding: 0

    },
    root: {
        marginLeft: '0px',
        /*marginRight: '1rem',*/
        marginRight: '0px',
        display: 'inline-block'
    },
    fieldGroup: {
        border: 'none',
        textAlignLast: 'center'
    }
};


export const textFieldStylesWeightage: Partial<ITextFieldStyles> = {
    field: {
        color: palette.neutralSecondary,
        padding: 0


    },
    root: {
        //marginLeft: '1rem',
        //marginRight: '1rem',
        marginLeft: '0px',
        marginRight: '0px',
        display: 'inline-block'
    },
    fieldGroup: {
        border: 'none',
        textAlignLast: 'center'
    }
};

export const paneHeaderStyle = mergeStyles({
    height: '4.3125rem'
});

export const paneHeaderTextStyle = mergeStyles({
    fontSize: '1.375rem',
    fontWeight: 600,
    width: '80%',
    float: 'left',
    margin: '20px'
});
export const footerMainTextStyle = mergeStyles({
    fontWeight: 600,
    fontSize: '1rem',
    marginLeft: '1rem',
    marginRight: '1rem'
});
export const copyLinkButtonStyle = mergeStyles({
    backgroundColor: BLUE,
    fontWeight: 600,
    fontSize: '0.875rem', // 14px
    height: '2.5rem',
    /* marginLeft: '1rem',*/
    /* marginRight: '1rem',*/
    width: '30%',
    display: 'inline-block',
    minWidth: '54px',
    color: '#ffffff',
    borderRadius: '3px',
    ':hover': {
        color: '#ffffff'
    }
    /*  padding:'5%'*/

});

export const selectLinkButtonStyle = mergeStyles({
    backgroundColor: GREEN,
    fontWeight: 600,
    fontSize: '0.875rem', // 14px
    height: '2.5rem',
    /* marginLeft: '1rem',*/
    /* marginRight: '1rem',*/
    width: '30%',
    display: 'inline-block',
    minWidth: '54px',
    color: '#ffffff',
    borderRadius: '3px',
    ':hover': {
        color: '#ffffff'
    }
    /*  padding:'5%'*/

});

export const rejectButtonStyle = mergeStyles({
    backgroundColor: MODERATE_RED,
    fontWeight: 600,
    fontSize: '0.875rem', // 14px
    height: '2.5rem',
    marginLeft: '1rem',
    /* marginRight: '1rem',*/
    width: '30%',
    borderColor: MODERATE_RED,
    display: 'inline-block',
    minWidth: '54px !important',
    color: '#ffffff',
    borderRadius: '3px',
    /* padding: '5%'*/

});

export const noShowButtonStyle = mergeStyles({
    backgroundColor: YELLOW,
    fontWeight: 600,
    fontSize: '0.875rem', // 14px
    height: '2.5rem',
    marginLeft: '1rem',
    /* marginRight: '1rem',*/
    width: '30%',
    borderColor: YELLOW,
    display: 'inline-block',
    minWidth: '54px',
    color: '#ffffff',
    borderRadius: '3px'
});

export const RateLabelStyle = mergeStyles({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    position: 'relative',
    top: '0.5rem'
});

export const RatingButtonStyle = mergeStyles({
    fontSize: '15px',
    //fontWeight: 'bold',
    verticalAlign: '-webkit-baseline-middle'


});


export const copyIconStyle = mergeStyles({
    marginRight: '0.5em'
});
export const settingsContainerStyle = mergeStyles({
    marginLeft: '1.25rem',
    width: '90%'
});
export const ratingsContainerStyle = mergeStyles({
    marginLeft: '1.25rem',
    width: '90%'
});
